import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Eye } from 'lucide-react';

const CreatorSets = () => {
    const [sets, setSets] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSets();
    }, []);

    const fetchSets = async () => {
        const token = localStorage.getItem('paradise_token');
        if (!token) return;

        try {
            const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';
            const res = await fetch(`${API_BASE}/api/sets`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setSets(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-8">
                <h2 className="text-2xl font-bold">My Sets</h2>
                <button
                    onClick={() => navigate('/creator/sets/new')}
                    className="flex items-center space-x-2 bg-black text-white px-4 py-2 rounded-md text-sm font-bold hover:bg-gray-800 transition-colors"
                >
                    <Plus size={16} />
                    <span>NEW SET</span>
                </button>
            </div>

            {loading ? (
                <div className="text-center py-12 text-gray-400 text-sm">LOADING SETS...</div>
            ) : sets.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-lg border border-dashed border-gray-300">
                    <p className="text-gray-500 mb-4">You haven't created any sets yet.</p>
                    <button onClick={() => navigate('/creator/sets/new')} className="text-black font-bold underline text-sm">Create your first set</button>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {sets.map(set => (
                        <div key={set._id} className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden group hover:border-black transition-colors">
                            <div className="h-48 bg-gray-100 relative">
                                {set.coverMedia ? (
                                    <img
                                        src={
                                            set.coverMedia.variants?.[0] ||
                                            `https://imagedelivery.net/${process.env.REACT_APP_CLOUDFLARE_ACCOUNT_HASH}/${set.coverMedia.cloudflareImageId || set.coverMedia.id}/public`
                                        }
                                        alt={set.title}
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-300 text-xs font-mono uppercase">No Cover</div>
                                )}
                                <div className="absolute top-2 right-2 bg-black/50 text-white text-[10px] px-2 py-1 rounded backdrop-blur-md uppercase font-bold">
                                    {set.status}
                                </div>
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-lg mb-1 truncate">{set.title}</h3>
                                <p className="text-xs text-gray-500 mb-4">Last updated: {new Date(set.updatedAt).toLocaleDateString()}</p>

                                <div className="flex items-center justify-between">
                                    <button
                                        onClick={() => navigate(`/creator/sets/${set._id}`)}
                                        className="text-xs font-bold uppercase tracking-wide flex items-center space-x-1 hover:text-blue-600"
                                    >
                                        <Edit size={14} />
                                        <span>Edit</span>
                                    </button>
                                    <button className="text-xs font-bold uppercase tracking-wide flex items-center space-x-1 text-gray-400 hover:text-black">
                                        <Eye size={14} />
                                        <span>Preview</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CreatorSets;
